// extracted by mini-css-extract-plugin
export default {"tableActionBoxContainer":"TheTableActionBox_tableActionBoxContainer__ZeoTU"};